<template>
  <div class="ApplicationContainer">

    <InitializeApp v-if="!initialized"/>
    <RouterView v-else/>

    <NotificationContainer/>
  </div>
</template>

<script>
import {mapState} from "vuex";
import InitializeApp from "./views/utilities/InitializeApp";
import NotificationContainer from "./components/SystemNotifications/NotificationContainer";

export default {
  name: 'app',
  components: {InitializeApp, NotificationContainer},
  computed: {
    ...mapState(['initialized'])
  }
}
</script>

<style lang="scss">
  @import "assets/scss/app";
</style>